import { stdObject } from "../../data/types/stdObject";
import BasicButton from "../BasicButton";
import BasicInput from "../BasicInput";

export default function Header({
  title = "",
  mainColor = "",
  squareButtons = [],
  squareInputs = [],
  date = "",
}: {
  title: string;
  mainColor: string;
  squareButtons: Array<stdObject | any>;
  squareInputs?: Array<stdObject>;
  date: string;
}) {
  return (
    <div className="documentBar" style={{ backgroundColor: mainColor }}>
      {" "}
      {squareInputs.map((e, index) => (
        <BasicInput
          key={index}
          type={e.type}
          value={e.value ?? ""}
          active={e.active}
          onChange={e.onChange}
        />
      ))}
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14 }}>{title}</div>

        <div>{date}</div>
      </div>
      {squareButtons.map(
        (e, index) =>
          e && (
            <BasicButton
              Icon={e.Icon}
              key={index}
              color={e.color}
              onClick={e.onClick}
            />
          ),
      )}
    </div>
  );
}
